(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-2026"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest && event.target.closest('.hw26--compact .hw26-cta');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const section = link.closest('.hw26').querySelector(link.getAttribute('href'));
  if (!section) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  let headerBottom = 0;
  document.querySelectorAll('header, .shopify-section-group-header-group').forEach(function(header) {
    const style = getComputedStyle(header);
    const rect = header.getBoundingClientRect();
    if ((style.position === 'sticky' || style.position === 'fixed') && rect.width > innerWidth * 0.5 && rect.bottom > 0 && rect.top < 180) {
      headerBottom = Math.max(headerBottom, rect.bottom);
    }
  });
  const heading = section.querySelector('.hw26-heading') || section;
  const destination = Math.max(0, window.scrollY + heading.getBoundingClientRect().top - headerBottom - 12);
  window.scrollTo({top:destination,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
}, true);

  } catch(e) { console.error(e); }
})();
})();
